/**
 * Cosmetic M3: trang trí tiệm + đồng phục, mua bằng xu cao cấp.
 * IAP chưa bật ở MVP (master-plan 3.5) — xu cao cấp chỉ kiếm từ
 * thành tựu, sưu tập và đơn lớn. Thuần trang trí, không ảnh hưởng kinh tế.
 */
import type { Cosmetic, DuLieuGame, TrangThaiGame } from './types.js';

/** Tìm món cosmetic theo mã. Ném lỗi nếu mã lạ. */
export function layCosmetic(duLieu: DuLieuGame, ma: string): Cosmetic {
  const mon = duLieu.cosmetic.cosmetic.find((c) => c.ma === ma);
  if (!mon) throw new Error(`Mã cosmetic lạ: ${ma}.`);
  return mon;
}

/**
 * Mua cosmetic bằng xu cao cấp. Ném lỗi tiếng Việt nếu đã sở hữu
 * hoặc không đủ xu cao cấp.
 */
export function muaCosmetic(state: TrangThaiGame, duLieu: DuLieuGame, ma: string): void {
  const mon = layCosmetic(duLieu, ma);
  if (state.cosmeticSoHuu.includes(ma)) {
    throw new Error('Bạn đã sở hữu món này rồi.');
  }
  if (state.xuCaoCap < mon.giaXuCaoCap) {
    throw new Error(
      `Cần ${mon.giaXuCaoCap} xu cao cấp (đang có ${state.xuCaoCap}). ` +
        'Hoàn thành thành tựu, sưu tập và đơn lớn để nhận thêm.',
    );
  }
  state.xuCaoCap -= mon.giaXuCaoCap;
  state.cosmeticSoHuu.push(ma);
}

/**
 * Dùng cosmetic đã sở hữu (trang trí tiệm hoặc đồng phục).
 * Ném lỗi nếu chưa sở hữu.
 */
export function dungCosmetic(state: TrangThaiGame, duLieu: DuLieuGame, ma: string): void {
  const mon = layCosmetic(duLieu, ma);
  if (!state.cosmeticSoHuu.includes(ma)) {
    throw new Error('Bạn chưa sở hữu món này.');
  }
  if (mon.loai === 'trangTri') {
    state.cosmeticTrangTri = ma;
  } else {
    state.cosmeticDongPhuc = ma;
  }
}
